export const APP_START_UP = 'APP_START_UP';

export const APP_UPDATE_AVAILABLE = 'APP_UPDATE_AVAILABLE';



// WEBPACK FOOTER //
// ./src/state/app/types.js